module.exports = __webpack_public_path__ + "ENG_SPS4-Pants-1efa6ba5aed6eaeb145ce8ae1b938a05.png";